export const getProfileVerifiedUsersNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'USER_VERIFIED_PROFILE');

export const getProfileUpdatedUsersNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'USER_UPDATED_PROFILE');

export const getUserAppliedNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'USER_APPLIED');

export const getJobApplicationNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'APPLICATION_STATUS_UPDATED');

export const getJobCreatedNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'JOB_CREATED');

export const getCompanyCreatedNotifications = (state) => state.notifications.data.filter((i) => i.notificationType === 'COMPANY_VERIFIED_PROFILE');